import React from 'react';
import { connect } from 'react-redux';

import HelmetMeta from '../../components/HelmetMeta';

const NoMatch = ({ i18n }) => {
  const { translations = {}, locale } = i18n || {};
  const { pagenotfound = {} } = translations[locale] || {};

  const seo = {
    seo_title: 'Page not found',
  };

  return (
    <div>
      <div className="sec-intro">
        <h2 className="sec-intro__title">{pagenotfound.title}</h2>
      </div>
      <div className="container">
        <p className="align-center">{pagenotfound.desc}</p>
      </div>
      <HelmetMeta seo={seo} status="404" />
    </div>
  );
};
const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(NoMatch);

export { NoMatch as NoMatchComponent }; // <- For component Unit Test
export default connectStore;
